import { Component } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { isB, isM, roundToString, roundToNumber, trackByIndex, isTorf, isMudde, isQuellsediment } from 'src/app/data-model';

@Component({
    standalone: false,
    selector: 'bp-substrate-horizonte',
    templateUrl: './substrate-horizonte.component.html',
    styleUrls: ['./hl-area.component.css', '../bohrpunkt-boden/bohrpunkt-boden.component.css'],
    
})
export class SubstrateHorizonteComponent extends HlAreaComponent {
	trackByIndex = trackByIndex;

	fieldNameMap: Record<string, string> = {
		'STiefe': 'Tiefe',
		'SMächtigkeit': 'Mächtigkeit',
		'Substrat': 'Substrat',
		'Wechselschichtung': 'Wechsel',
		'Humusgehalt': 'Humus',
		'Lagerungsdichte': 'Lager.',
		'Skelettgehalt': 'Skelett',
		'Karbonat': 'Karbonat',
		'Torfart1': 'Torfart 1',
		'Torfart2': 'Torfart 2',
		'Torfart3': 'Torfart 3',
		'Torf-Zersetzungsgrad': 'Zersetz.',
		'Mudde-Konsistenz': 'Konsist.',
		'Substanzvolumen': 'Subst.vol.',
		'Besonderheiten': 'Besond.',
		'Farbe': 'Farbe',
		'HTiefe': 'Tiefe',
		'HMächtigkeit': 'Mächtigkeit',
		'Horizont1': 'Horizont 1',
		'Horizont2': 'Horizont 2',
		'Horizont3': 'Horizont 3'
	};
	
	roundToString = roundToString;
	roundToNumber = roundToNumber;
	isTorf = isTorf;
	isMudde = isMudde;
	isQuellsediment = isQuellsediment;

  onAddSubstratZeile(i = -1) {
		const l = this.data.Substratfolge.length;
		const cp = { torfarten: ['', '', ''] };
    if (i === -1) this.data.Substratfolge.push(cp);
		else this.data.Substratfolge.splice(i, 0, cp);
		this.vs.dirty.next(true);
  }

  onRemoveSubstratZeile(i: number) {
		const tiefe = this.data.Substratfolge[i].tiefe;
		// clearCommentsNoSave verwenden um mehrfaches Speichern zu vermeiden
		// Das Speichern erfolgt erst wenn der User explizit speichert (dirty=true)
		this.vs.clearCommentsNoSave(`STiefe[${i}]`);
		this.vs.clearCommentsNoSave(`SMächtigkeit[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Substrat[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Wechselschichtung[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Humusgehalt[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Lagerungsdichte[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Skelettgehalt[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Karbonat[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`nWSK[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Torfart1[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Torfart2[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Torfart3[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Zersetzungsgrad[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Zersetzungsgrad Mudde[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Substanzvolumen[${i}](${tiefe}cm)`);
		this.vs.clearCommentsNoSave(`Farbe[${i}](${tiefe}cm)`);

		this.data.Substratfolge.splice(i, 1);
		this.vs.dirty.next(true);
  }

	onAddHorizontZeile(i = -1) {
		const l = this.data.Horizontfolge.length;
		const cp = { horizonte: [null, null, null] };
		if (i === -1) this.data.Horizontfolge.push(cp);
		else this.data.Horizontfolge.splice(i, 0, cp);
		this.vs.dirty.next(true);
	}

	onRemoveHorizontZeile(i: number) {
		const hf = this.data.Horizontfolge[i];
		const hs = hf.horizonte;
		const tiefe = hf.tiefe;
		// clearCommentsNoSave verwenden um mehrfaches Speichern zu vermeiden
		this.vs.clearCommentsNoSave(`HTiefe[${i}]`);
		this.vs.clearCommentsNoSave(`HMächtigkeit[${i}](${tiefe}cm)`);
		for (let j = 0; j < hs.length; ++j) {
			this.vs.clearCommentsNoSave(`Horizont${j+1}[${i}](${tiefe}cm)`);
		}

		this.data.Horizontfolge.splice(i, 1);
		this.vs.dirty.next(true);
	}
	
	colSpanSubstrate(): number {
		// B: 11 Spalten, M: 17 Spalten (3 Torfarten statt 1), G: 11 Spalten
		return isB(this.data) ? 11 : (isM(this.data) ? 17 : 11);
	}

	/** Feldpräfixe für Substratzeilen-Kommentare */
	substratFieldPrefixes(): string[] {
		const base = ['STiefe', 'SMächtigkeit', 'Substrat', 'Wechselschichtung', 'Skelettgehalt', 'Karbonat'];
		if (isM(this.data)) {
			return [...base, 'Torfart1', 'Torfart2', 'Torfart3', 'Torf-Zersetzungsgrad', 'Mudde-Konsistenz', 'Substanzvolumen', 'Besonderheiten', 'Farbe'];
		} else if (isB(this.data)) {
			return [...base, 'Humusgehalt', 'Lagerungsdichte'];
		} else {
			return [...base, 'Humusgehalt', 'Lagerungsdichte', 'Farbe'];
		}
	}

	/** Feldpräfixe für Horizontzeilen-Kommentare */
	horizontFieldPrefixes(): string[] {
		return ['HTiefe', 'HMächtigkeit', 'Horizont1', 'Horizont2', 'Horizont3'];
	}

	/** Prüft ob eine Substratzeile unaufgelöste Kommentare hat */
	hasSubstratRowComments(i: number, tiefe?: number): boolean {
		const suffix = tiefe !== undefined ? `(${tiefe}cm)` : '';
		for (const prefix of this.substratFieldPrefixes()) {
			// Mit Suffix
			const c1 = this.vs.hasComments(`${prefix}[${i}]${suffix}`);
			if (c1 && !c1.resolved) return true;
			// Ohne Suffix (für STiefe)
			if (suffix) {
				const c2 = this.vs.hasComments(`${prefix}[${i}]`);
				if (c2 && !c2.resolved) return true;
			}
		}
		return false;
	}

	/** Prüft ob eine Horizontzeile unaufgelöste Kommentare hat */
	hasHorizontRowComments(i: number, tiefe?: number): boolean {
		const suffix = tiefe !== undefined ? `(${tiefe}cm)` : '';
		for (const prefix of this.horizontFieldPrefixes()) {
			const c1 = this.vs.hasComments(`${prefix}[${i}]${suffix}`);
			if (c1 && !c1.resolved) return true;
			if (suffix) {
				const c2 = this.vs.hasComments(`${prefix}[${i}]`);
				if (c2 && !c2.resolved) return true;
			}
		}
		return false;
	}
	
	schichtNWSK(i: number): string | undefined {
		const result = this.es.evaluate(`SnWSK[${i}]`) as number | undefined;
		if (result === undefined || result === null || isNaN(result)) return undefined;
		return Number(result).toFixed(2).replace('.', ',');
	}

	schichtNWSKGesamt(): string | undefined {
		// Live berechnen statt gespeicherten Wert lesen
		const v = this.es.evaluate('nWSK') as number | undefined;
		if (v === undefined || v === null || isNaN(v)) return undefined;
		// Wert auch im Dokument aktualisieren für Speicherung
		this.data.extendedHeader.nWsk = v;
		return Number(v).toFixed(2).replace('.', ',');
	}

	substratFeuchte(): string | undefined {
		// Live berechnen statt gespeicherten Wert lesen
		const v = this.es.evaluate('Substratfeuchte') as string | undefined;
		if (v === undefined) return undefined;
		// Wert auch im Dokument aktualisieren für Speicherung
		this.data.header.substratFeuchte = v;
		return v;
	}
}
